import React from "react";
import { Route, Routes } from "react-router-dom";
import CaseAllDataPage from "../components/_Pages/CaseAllDataPage/CaseAllDataPage";
import CaseHistoryPage from "../components/_Pages/CaseHistoryPage/CaseHistoryPage";
import CaseAccountingPage from "../components/_Pages/CaseAccountingPage/CaseAccountingPage";
import CaseFileGeneratePage from "../components/_Pages/CaseFileGeneratePage/CaseFileGeneratePage";
import CasePaidTaskPage from "../components/_Pages/CasePaidTaskPage/CasePaidTaskPage";
import CaseReferenceFilePage from "../components/_Pages/CaseReferenceFilePage/CaseReferenceFilePage";
import CasePage from "../components/_Pages/CasePage/CasePage";
import CaseRelatedActions from "../components/Case/CaseRelatedActions/CaseRelatedActions";
import CaseImportDocumentsFromRelatedCasePage from "../components/_Pages/CaseImportDocumentsFromRelatedCasePage/CaseImportDocumentsFromRelatedCasePage";
import CaseExecutionJobsPage from "../components/_Pages/CaseExecutionJobsPage/CaseExecutionJobsPage";
import CaseExecutionJobDetailsPage from "../components/_Pages/CaseExecutionJobDetailsPage/CaseExecutionJobDetailsPage";
import { CallProvider } from "../provider/CallProvider";
import { DrawerProvider } from "../provider/DrawerProvider";
import CaseRouteProvider from "../provider/CaseRouteProvider";
import { AiChatProvider } from "../provider/AiChatProvider";
import { AiEventStreamProvider } from "../provider/AiEventStreamProvider";
import { isLitigationCase } from "../types/AbstractCase";
import { ProductUnion } from "../types/ProductUnion";
import CaseHelmet from "../components/Case/CaseHelmet.tsx";

const previousInstanceImportConfiguration = {
  headline: "Dokumente aus Vorinstanz importieren",
  getRelatedCaseId: (product: ProductUnion) => {
    if (!isLitigationCase(product)) {
      return null;
    }

    return product.previousInstanceCase?.id;
  },
};

const mainCaseImportConfiguration = {
  headline: "Dokumente aus Hauptverfahren importieren",
  getRelatedCaseId: (product: ProductUnion) => {
    if (product.productCategory !== "administrativeLaw" || product.administrativeCaseType === "main") {
      return null;
    }

    return product.linkedAdministrativeLawCaseIds["mainCaseId"];
  },
};

const CaseRoutes = () => {
  return (
    <CaseRouteProvider>
      <CaseHelmet />
      <DrawerProvider>
        <CallProvider>
          <AiEventStreamProvider>
            <AiChatProvider>
              <CaseRelatedActions />
              <Routes>
                <Route path={"/"} element={<CasePage />} />
                <Route path={"/alle-daten"} element={<CaseAllDataPage />} />
                <Route path={"/konto"} element={<CaseAccountingPage />} />
                <Route path={"/verlauf"} element={<CaseHistoryPage />} />
                <Route path={"/execution-jobs"} element={<CaseExecutionJobsPage />} />
                <Route path={"/execution-jobs/:executionJobId"} element={<CaseExecutionJobDetailsPage />} />
                <Route path={"/datei-generieren"} element={<CaseFileGeneratePage />} />
                <Route
                  path={"/dokumente-importieren/vorinstanz"}
                  element={<CaseImportDocumentsFromRelatedCasePage {...previousInstanceImportConfiguration} />}
                />
                <Route
                  path={"/dokumente-importieren/hauptverfahren"}
                  element={<CaseImportDocumentsFromRelatedCasePage {...mainCaseImportConfiguration} />}
                />
                <Route path={"/ausschreibung/:paidTaskId"} element={<CasePaidTaskPage />} />
                <Route path={"/handakte/:courtAppointmentId"} element={<CaseReferenceFilePage />} />
              </Routes>
            </AiChatProvider>
          </AiEventStreamProvider>
        </CallProvider>
      </DrawerProvider>
    </CaseRouteProvider>
  );
};

export default CaseRoutes;
